import { CodeNameModel } from 'components/common/types';
import { AdvancedFilter } from '../Filters.types';
import { AdvancedFiltersProps, DateFilterKey, isDateFilterKey, isTextFilterKey } from './AdvancedFilters.types';
import { DateFilterPanel } from './DateFilterPanel';
import { LookupSearchPanel } from './LookupSearchPanel';
import { TextFilterPanel } from './TextFilterPanel';

interface AdvancedFiltersPanelProps {
  activeFilterKey: string | null;
  activeFilter: AdvancedFilter | null;
  filters: AdvancedFiltersProps['filters'];
  textSearch: string;
  onTextSearchChange: (value: string) => void;
  onDateChange: (dateKey: DateFilterKey, value: Date) => void;
  onLookupSelect: (value: CodeNameModel) => void;
}

export const AdvancedFiltersPanel = ({
  activeFilterKey,
  activeFilter,
  filters,
  textSearch,
  onTextSearchChange,
  onDateChange,
  onLookupSelect,
}: AdvancedFiltersPanelProps): React.ReactElement | null => {
  if (!activeFilterKey || !activeFilter) return null;

  let panelContent: React.ReactElement | null = null;

  if (isDateFilterKey(activeFilterKey)) {
    panelContent = (
      <DateFilterPanel
        dateKey={activeFilterKey}
        selectedDate={filters[activeFilterKey]}
        onChange={(value) => onDateChange(activeFilterKey, value)}
      />
    );
  } else if (isTextFilterKey(activeFilterKey)) {
    panelContent = (
      <TextFilterPanel
        filterKey={activeFilterKey}
        value={textSearch}
        placeholder={activeFilter.placeholder ?? ''}
        onChange={onTextSearchChange}
      />
    );
  } else if (activeFilter.loadData) {
    panelContent = (
      <LookupSearchPanel
        key={activeFilterKey}
        filterKey={activeFilterKey}
        placeholder={activeFilter.placeholder ?? ''}
        loadData={activeFilter.loadData}
        onSelect={onLookupSelect}
        dataTestId={`search-${activeFilterKey}-filter`}
      />
    );
  }

  if (!panelContent) return null;

  return <div className="absolute top-0 left-52">{panelContent}</div>;
};
